import { defineStore } from 'pinia'
import {
  apiGetAdditionalCostRequestNotificationCounts,
  apiMarkAdditionalCostRequestNotificationsRead,
} from '@/services/additionalCostRequestService'
import { useGlobalStore } from '@/stores/global-store'
import RoleCode from '@/constants/RoleCode'

// Badge cạnh menu "Đề xuất phát sinh" - xem docs/receive-backend/0017-badge-de-xuat-phat-sinh.md.
// Dùng chung: AppSidebar poll định kỳ (30-60s) + gọi lại ngay sau hành động đổi số (tạo/duyệt/từ chối);
// trang Đề xuất PS gọi markNotificationsRead() khi mở menu xong.
export const useAdditionalCostBadgeStore = defineStore('additionalCostBadge', {
  state: () => ({
    octCount: 0,
    bodCount: 0,
    approvedCount: 0,
  }),
  getters: {
    // Text hiển thị badge theo ĐÚNG vai trò hiện tại (mục 4 doc 0017) - KHÔNG cộng gộp oct_count +
    // approved_count (2 số mang 2 ý nghĩa khác nhau). Role không liên quan -> null (ẩn badge).
    displayText(state): string | null {
      const roleCode = useGlobalStore().roleCode
      if (roleCode === RoleCode.OCT) {
        if (state.octCount === 0 && state.approvedCount === 0) return null
        return `${state.octCount} | ${state.approvedCount}`
      }
      if (roleCode === RoleCode.BOD) {
        return state.bodCount > 0 ? String(state.bodCount) : null
      }
      if (roleCode === RoleCode.OPS_TT || roleCode === RoleCode.CUS) {
        return state.approvedCount > 0 ? String(state.approvedCount) : null
      }
      return null
    },
  },
  actions: {
    async fetchCounts() {
      try {
        const res = await apiGetAdditionalCostRequestNotificationCounts()
        const data = res?.data ?? {}
        this.octCount = data.oct_count ?? 0
        this.bodCount = data.bod_count ?? 0
        this.approvedCount = data.approved_count ?? 0
      } catch {
        // Lỗi (mất mạng / chưa đăng nhập) -> giữ số cũ
      }
    },
    // Đánh dấu đã đọc rồi refresh lại số đếm ngay (mục 3 doc 0017), kể cả khi mark-read lỗi -
    // vẫn đồng bộ lại state mới nhất từ server thay vì để badge hiện sai.
    async markNotificationsRead() {
      try {
        await apiMarkAdditionalCostRequestNotificationsRead()
      } finally {
        await this.fetchCounts()
      }
    },
  },
})
